(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (()=>{const drawer=document.querySelector('[data-cart-drawer]'),backdrop=document.querySelector('[data-cart-backdrop]'),open=document.querySelector('[data-cart-open]'),close=document.querySelector('[data-cart-close]');if(!drawer||!backdrop||!open||!close)return;const set=v=>{drawer.classList.toggle('is-open',v);backdrop.classList.toggle('is-open',v);drawer.setAttribute('aria-hidden',String(!v));open.setAttribute('aria-expanded',String(v));document.body.classList.toggle('menu-open',v)};open.addEventListener('click',()=>set(true));close.addEventListener('click',()=>set(false));backdrop.addEventListener('click',()=>set(false));document.addEventListener('keydown',e=>{if(e.key==='Escape')set(false)})})();
  (()=>{const menu=document.querySelector('[data-mobile-menu]'),open=document.querySelector('[data-menu-open]'),closes=document.querySelectorAll('[data-menu-close]'),backdrop=document.querySelector('.mobile-menu-backdrop');if(!menu||!open)return;const panels=[...menu.querySelectorAll('[data-menu-panel]')];const reset=()=>{panels.forEach(panel=>panel.classList.remove('is-active','is-behind'));menu.querySelector('#menu-panel-main')?.classList.add('is-active');menu.querySelectorAll('[data-menu-panel-target]').forEach(button=>button.setAttribute('aria-expanded','false'))};const set=v=>{menu.classList.toggle('is-open',v);backdrop?.classList.toggle('is-open',v);menu.setAttribute('aria-hidden',String(!v));open.setAttribute('aria-expanded',String(v));document.body.classList.toggle('menu-open',v);if(!v)reset()};open.addEventListener('click',()=>set(true));closes.forEach(close=>close.addEventListener('click',()=>set(false)));menu.querySelectorAll('[data-menu-panel-target]').forEach(button=>button.addEventListener('click',()=>{const current=button.closest('[data-menu-panel]'),target=menu.querySelector('#'+button.dataset.menuPanelTarget);if(!current||!target)return;current.classList.remove('is-active');current.classList.add('is-behind');target.classList.add('is-active');button.setAttribute('aria-expanded','true')}));menu.querySelectorAll('[data-menu-back]').forEach(button=>button.addEventListener('click',()=>{const current=button.closest('[data-menu-panel]'),target=menu.querySelector('#'+button.dataset.menuBack);if(!current||!target)return;current.classList.remove('is-active');target.classList.remove('is-behind');target.classList.add('is-active');target.querySelectorAll('[data-menu-panel-target]').forEach(item=>item.setAttribute('aria-expanded','false'))}));document.addEventListener('keydown',event=>{if(event.key==='Escape')set(false)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  (()=>{const dialog=document.querySelector('[data-promo-dialog]');if(!dialog||sessionStorage.getItem('aurea-promo-seen'))return;const delay=Number(dialog.dataset.delay||3000);setTimeout(()=>{dialog.showModal();sessionStorage.setItem('aurea-promo-seen','1')},delay);dialog.querySelector('[data-promo-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-reviews-track]');
    const cards = Array.from(track.children);
    const previous = carousel.querySelector('[data-reviews-prev]');
    const next = carousel.querySelector('[data-reviews-next]');
    let index = 0;

    const visibleCards = () => {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 990) return 2;
      return 5;
    };

    const update = () => {
      const maximum = Math.max(0, cards.length - visibleCards());
      index = Math.min(index, maximum);
      const step = cards[0].getBoundingClientRect().width + 16;
      track.style.transform = `translate3d(${-index * step}px, 0, 0)`;
      previous.disabled = index === 0;
      next.disabled = index === maximum;
    };

    previous.addEventListener('click', () => {
      index = Math.max(0, index - 1);
      update();
    });

    next.addEventListener('click', () => {
      index = Math.min(cards.length - visibleCards(), index + 1);
      update();
    });

    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
